// @ts-nocheck

import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from './contexts/AppContextProvider';
import { selectUserConnected } from './selectors/user/userPrimary.selector';

const RuntimeListener = ({ children }) => {
  const isUserConnected = useSelector(selectUserConnected);
  const initialized = useRef(false);
  const { onLoginSucceed, setOnLoginSucceed } = useAppContext();

  useEffect(() => {
    if (initialized.current && isUserConnected) {
      if (typeof onLoginSucceed === 'function') {
        onLoginSucceed();
        setOnLoginSucceed(null);
      }
    }
  }, [isUserConnected, onLoginSucceed, setOnLoginSucceed]);

  useEffect(() => {
    initialized.current = true;
  }, []);

  return children;
};

export default RuntimeListener;
